<template>
  <Modal ref="modal" title="Faturas Pendentes por Quantidade de Aulas" @cancel="close">
    <form class="form-container" @submit.prevent="handleSubmit">
      <div class="input-container">
        <Select class="input-full" :options="tipoOptions" legend="Tipo de aula" placeholder="Selecione"
          :modelValue="tipo" @update:modelValue="$event => (this.tipo = $event)" :disabled="loading" />

        <Input class="input-full" type="number" :modelValue="quantidade"
          @update:modelValue="$event => (this.quantidade = $event)" legend="Quantidade de aulas" :disabled="loading" />
      </div>

      <Button type="submit" text="Pesquisar" color="primary" :disabled="loading">
        <Magnify :size="18" />
      </Button>
    </form>

    <div class="loading" v-if="loading">
      <LoadingSpinner />
    </div>

    <div v-if="!loading && consulted" class="table-container">
      <Select class="input-full" :options="schemaOptions" legend="Autoescola" placeholder="Selecione"
        :modelValue="schema" @update:modelValue="$event => (this.schema = $event)" :disabled="loading" />

      <Table :headers="['Nome', 'Data de bloqueio', 'Quantidade de aulas']">
        <tr v-if="!schema">
          <td colspan="3">
            <div class="text-center">
              Selecione uma autoescola.
            </div>
          </td>
        </tr>
        <tr v-else-if="!filteredFaturas.length">
          <td colspan="3">
            <div class="text-center">
              Sem resultados.
            </div>
          </td>
        </tr>
        <tr v-else v-for="fatura in filteredFaturas" :key="fatura.nome">
          <td>{{ fatura.nome }}</td>
          <td>{{ utils.formatOnlyDate(fatura.data_bloqueio) }}</td>
          <td>{{ fatura.aulas }}</td>
        </tr>
      </Table>
    </div>
  </Modal>
</template>

<script>
import Modal from 'core/Modal'
import LoadingSpinner from 'core/LoadingSpinner'
import Select from 'core/Select'
import Input from 'core/Input'
import Button from 'core/Button'
import Table from 'core/Table'
import Magnify from 'icons/Magnify'
import _export from '../../../../services/export'
import utils from '../../../../services/utils'

export default {
  name: 'FaturasPendentes',
  components: {
    Modal,
    LoadingSpinner,
    Select,
    Input,
    Button,
    Table,

    Magnify,
  },
  data() {
    return {
      utils: utils,
      schema: '',
      tipo: 'aulas_teoricas',
      quantidade: '0',
      schemaOptions: [],
      tipoOptions: [
        { value: 'aulas_teoricas', text: 'Aulas teóricas' },
        { value: 'aulas_praticas', text: 'Aulas práticas' },
      ],
      faturas: [],
      consulted: false,
      loading: false,
    }
  },
  computed: {
    filteredFaturas() {
      if (this.schema) {
        let faturas = this.faturas.filter(fatura => fatura.cfcId === this.schema)[0].faturas

        if (typeof faturas === "object") {
          faturas = Object.values(faturas)

          return faturas
        }

        return faturas
      }

      return []
    }
  },
  methods: {
    open() {
      this.$refs.modal.open()
    },
    close() {
      this.schema = ''
      this.tipo = 'aulas_teoricas'
      this.quantidade = '0'
      this.schemaOptions = []
      this.loading = false
      this.$refs.modal.close()
    },
    async handleSubmit() {
      if (!this.validateInputs()) {
        return
      }

      this.loading = true
      this.schema = ''

      const params = {
        amount: this.quantidade,
        type: this.tipo,
      }

      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/faturamento/faturaspendentes`, {
        params,
      })
        .then((res) => {
          this.faturas = res.body.dados

          this.schemaOptions = res.body.dados
            .filter(fatura => fatura.cfcName !== "TESTE")
            .map(fatura => ({
              value: fatura.cfcId,
              text: fatura.cfcName,
            }))
        })
        .catch((err) => {
          this.toast(`Erro ao consultar: ${err.body.mensagem}`)
        })
        .finally(() => {
          this.loading = false
          this.consulted = true
        })
    },
    validateInputs() {
      if (!this.tipo || !this.quantidade) {
        this.$toasted.show('Preencha todos os campos.', {
          position: 'top-right',
        });

        return false;
      }

      return true
    },
  }
}
</script>

<style lang="scss" scoped>
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
}

.form-container {
  min-width: 50rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  .input-container {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;

    .input-full {
      flex: 1;
    }
  }

  .format-container {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    span {
      font-size: 1rem;
      font-weight: 600;
      line-height: 21.82px;
      color: #606264;
    }
  }

  button {
    justify-content: center;
  }
}

.table-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
</style>